/*
 * Cart gate: terms acceptance plus learner capture.
 * Forest Schools Education, 14 September 2026.
 *
 * 1. Points the terms tick at the right course terms page for what is in the basket.
 * 2. Gates the cart page, which had no tick at all.
 * 3. Asks who the course is for, and captures a name and email for every place
 *    when the buyer is booking for someone else.
 * 4. Records all of it on the order as cart attributes, so the enrolment
 *    automation can read it instead of someone reading a note by hand.
 */
(function () {
  'use strict';

  var VERSION = '1.0 (September 2026)';
  var HUB = '/pages/course-terms-and-conditions';
  var MAX_LEARNERS = 10;
  var MAP = [
    { tag: 'beach schools', url: '/pages/terms-beach-schools', label: 'Beach Schools Practitioner' },
    { tag: 'level 4', url: '/pages/terms-level-4', label: 'Trainer, Level 4' },
    { tag: 'level 3', url: '/pages/terms-level-3', label: 'Leader, Level 3' },
    { tag: 'level 2', url: '/pages/terms-level-2', label: 'Assistant, Level 2' },
    { tag: 'level 1', url: '/pages/terms-level-1', label: 'Foundation, Level 1' }
  ];

  var tagCache = {};
  var links = link(HUB, 'the course terms and conditions');
  var places = 1;
  var who = 'me';
  var learners = [];
  var writing = false;
  var lastSent = null;
  var saveTimer = null;

  function link(url, label) {
    return '<a href=' + url + ' target=_blank rel=noopener>' + label + '</a>';
  }

  function emailLooksReal(v) {
    v = (v || '').trim();
    var at = v.indexOf('@');
    if (at < 1) return false;
    var dot = v.indexOf('.', at);
    return dot > at + 1 && dot < v.length - 1 && v.indexOf(' ') === -1;
  }

  function addStyles() {
    if (document.getElementById('terms-gate-style')) return;
    var s = document.createElement('style');
    s.id = 'terms-gate-style';
    s.textContent =
      '.terms-gate{margin:0 0 14px}' +
      '.terms-gate>label{display:flex;align-items:flex-start;gap:10px;cursor:pointer;line-height:1.4}' +
      '.terms-gate input[type=checkbox]{flex:0 0 auto;width:18px;height:18px;margin-top:2px;cursor:pointer}' +
      '.terms-gate p{margin:0;font-size:.9em}' +
      '.terms-gate a{text-decoration:underline}' +
      '.lg{margin:14px 0 0;padding:12px;border:1px solid rgba(0,0,0,.15);border-radius:8px}' +
      '.lg-q{font-weight:600;margin:0 0 8px}' +
      '.lg-opts{display:flex;gap:18px;margin-bottom:6px;flex-wrap:wrap}' +
      '.lg-opts label{display:flex;align-items:center;gap:7px;cursor:pointer;font-size:.9em}' +
      '.lg-opts input{width:16px;height:16px;cursor:pointer}' +
      '.lg-fields{margin-top:10px}' +
      '.lg-row{margin-bottom:10px}' +
      '.lg-row strong{display:block;font-size:.82em;margin-bottom:4px;opacity:.75}' +
      '.lg-row input{width:100%;padding:9px 10px;margin-bottom:6px;border:1px solid rgba(0,0,0,.25);border-radius:6px;font-size:.92em;box-sizing:border-box}' +
      '.lg-row input.lg-bad{border-color:#c0392b;background:#fdf3f2}' +
      '.lg-note{margin:6px 0 0;font-size:.82em;opacity:.8}' +
      '.lg-warn{margin:8px 0 0;font-size:.85em;color:#c0392b}';
    document.head.appendChild(s);
  }

  function tagsFor(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var tags = (p && p.tags ? p.tags : []).map(function (t) { return String(t).toLowerCase(); });
        tagCache[handle] = tags;
        return tags;
      })
      .catch(function () { return []; });
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = 0;
        var handles = [];
        (cart.items || []).forEach(function (i) {
          qty += i.quantity || 0;
          if (i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle);
        });
        places = Math.max(1, Math.min(qty, MAX_LEARNERS));
        while (learners.length < places) learners.push({ name: '', email: '' });
        learners.length = places;
        return Promise.all(handles.map(tagsFor));
      })
      .then(function (sets) {
        var chosen = [];
        sets.forEach(function (tags) {
          for (var i = 0; i < MAP.length; i++) {
            if (tags.indexOf(MAP[i].tag) !== -1) {
              if (chosen.indexOf(MAP[i]) === -1) chosen.push(MAP[i]);
              return;
            }
          }
        });
        links = chosen.length
          ? chosen.map(function (c) { return link(c.url, c.label); }).join(', ')
          : link(HUB, 'the course terms and conditions');
        paint();
        save();
      })
      .catch(function () {});
  }

  function sentence() {
    return 'I have read and accept ' + links + ', and the ' +
      link('/policies/privacy-policy', 'privacy policy') + '.';
  }

  function q(s) { return JSON.stringify(s); }

  function learnerHtml(ctx) {
    var rows = '';
    for (var i = 0; i < places; i++) {
      var n = i + 1;
      rows +=
        '<div class=lg-row>' +
        (places > 1 ? '<strong>Learner ' + n + '</strong>' : '') +
        '<input type=text data-lg=name data-i=' + i + ' placeholder=' + q('Learner full name') + ' autocomplete=off>' +
        '<input type=email data-lg=email data-i=' + i + ' placeholder=' + q('Learner email address') + ' autocomplete=off>' +
        '</div>';
    }
    return (
      '<div class=lg>' +
      '<p class=lg-q>Who is this course for?</p>' +
      '<div class=lg-opts>' +
      '<label><input type=radio name=lg-' + ctx + ' value=me> For me</label>' +
      '<label><input type=radio name=lg-' + ctx + ' value=other> For someone else</label>' +
      '</div>' +
      '<div class=lg-fields hidden>' +
      rows +
      '<p class=lg-note>We send the course log in straight to the learner, so this must be the email they will use.</p>' +
      '</div>' +
      '<p class=lg-warn hidden></p>' +
      '</div>'
    );
  }

  function gateHtml(ctx) {
    return '<label><input type=checkbox data-terms><p data-sentence>' + sentence() + '</p></label>' +
      learnerHtml(ctx);
  }

  function syncInto(root, ctx) {
    var radios = root.querySelectorAll('input[name=lg-' + ctx + ']');
    Array.prototype.forEach.call(radios, function (r) { r.checked = r.value === who; });

    var fields = root.querySelector('.lg-fields');
    if (fields) fields.hidden = who !== 'other';

    Array.prototype.forEach.call(root.querySelectorAll('[data-lg]'), function (el) {
      var i = parseInt(el.getAttribute('data-i'), 10);
      var k = el.getAttribute('data-lg');
      if (!learners[i]) return;
      if (document.activeElement !== el && el.value !== learners[i][k]) el.value = learners[i][k];
      var bad = who === 'other' && el.value.trim() !== '' &&
        (k === 'email' ? !emailLooksReal(el.value) : false);
      el.classList.toggle('lg-bad', bad);
    });

    var p = root.querySelector('[data-sentence]');
    if (p && p.innerHTML !== sentence()) p.innerHTML = sentence();
  }

  function paintDrawer() {
    var box = document.querySelector('.cart-slide__policy');
    if (!box) return;
    box.classList.add('terms-gate');
    if (!box.querySelector('[data-sentence]') || box.querySelectorAll('.lg-row').length !== places) {
      var keep = box.querySelector('input[type=checkbox]');
      var wasChecked = keep ? keep.checked : false;
      box.innerHTML = gateHtml('drawer');
      var nb = box.querySelector('[data-terms]');
      if (nb) nb.checked = wasChecked;
    }
    syncInto(box, 'drawer');
  }

  function paintPage() {
    var btn = document.getElementById('main-cart-checkout');
    if (!btn) return;
    var gate = document.getElementById('terms-gate-page');
    if (!gate) {
      gate = document.createElement('div');
      gate.className = 'terms-gate';
      gate.id = 'terms-gate-page';
      gate.innerHTML = gateHtml('page');
      var wrap = btn.parentNode;
      if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(gate, wrap);
    } else if (gate.querySelectorAll('.lg-row').length !== places) {
      var t = gate.querySelector('[data-terms]');
      var was = t ? t.checked : false;
      gate.innerHTML = gateHtml('page');
      var nt = gate.querySelector('[data-terms]');
      if (nt) nt.checked = was;
    }
    syncInto(gate, 'page');
  }

  function paint() { paintDrawer(); paintPage(); enforce(); }

  function learnersOk() {
    if (who !== 'other') return true;
    for (var i = 0; i < places; i++) {
      var l = learners[i] || {};
      if (!(l.name || '').trim()) return false;
      if (!emailLooksReal(l.email)) return false;
    }
    return true;
  }

  function termsBoxes() {
    var list = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-terms]'), function (b) { list.push(b); });
    return list;
  }

  function termsTicked() {
    return termsBoxes().some(function (b) { return b.checked; });
  }

  function complete() { return termsTicked() && learnersOk(); }

  function enforce() {
    var ok = complete();

    var btn = document.getElementById('main-cart-checkout');
    if (btn) {
      var empty = btn.getAttribute('data-was-empty') === '1';
      btn.disabled = !ok || empty;
    }

    var express = document.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart');
    Array.prototype.forEach.call(express, function (el) { el.style.display = ok ? '' : 'none'; });

    var d = document.querySelector('.cart-slide__checkout-btn');
    if (d && !ok) d.disabled = true;
  }

  function blockedReason() {
    if (!learnersOk()) return 'Add a name and email for every learner to continue.';
    if (!termsTicked()) return 'Please accept the terms and conditions to continue.';
    return '';
  }

  function showReason() {
    var msg = blockedReason();
    Array.prototype.forEach.call(document.querySelectorAll('.lg-warn'), function (w) {
      w.textContent = msg;
      w.hidden = msg === '';
    });
  }

  function onClick(e) {
    var t = e.target;
    var hit = null;
    while (t && t !== document) {
      if (t.id === 'main-cart-checkout' ||
          (t.classList && t.classList.contains('cart-slide__checkout-btn'))) { hit = t; break; }
      t = t.parentNode;
    }
    if (!hit) return;
    if (!complete()) {
      e.preventDefault();
      e.stopPropagation();
      showReason();
    }
  }

  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(write, 400);
  }

  function write() {
    var attrs = {};
    var accepted = termsTicked() && learnersOk();

    attrs['Terms accepted'] = accepted ? 'Yes' : '';
    if (accepted) {
      var tmp = document.createElement('div');
      tmp.innerHTML = links;
      attrs['Terms version'] = VERSION;
      attrs['Terms accepted at'] = new Date().toISOString();
      attrs['Terms accepted for'] = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    } else {
      attrs['Terms version'] = '';
      attrs['Terms accepted at'] = '';
      attrs['Terms accepted for'] = '';
    }

    attrs['Booking for'] = who === 'other' ? 'Someone else' : 'The buyer';
    for (var i = 0; i < MAX_LEARNERS; i++) {
      var n = i + 1;
      var use = who === 'other' && i < places && learnersOk();
      attrs['Learner ' + n + ' name'] = use ? learners[i].name.trim() : '';
      attrs['Learner ' + n + ' email'] = use ? learners[i].email.trim() : '';
    }

    var key = JSON.stringify(attrs);
    if (writing || key === lastSent) return;
    writing = true;
    lastSent = key;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .catch(function () {})
      .then(function () { writing = false; });
  }

  function onChange(e) {
    var t = e.target;
    if (!t) return;

    if (t.type === 'checkbox' && t.hasAttribute && t.hasAttribute('data-terms')) {
      termsBoxes().forEach(function (b) { if (b !== t) b.checked = t.checked; });
      enforce();
      showReason();
      save();
      return;
    }

    if (t.type === 'radio' && (t.name === 'lg-page' || t.name === 'lg-drawer')) {
      who = t.value === 'other' ? 'other' : 'me';
      paint();
      showReason();
      save();
    }
  }

  function onInput(e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-lg')) return;
    var i = parseInt(t.getAttribute('data-i'), 10);
    var k = t.getAttribute('data-lg');
    if (!learners[i]) learners[i] = { name: '', email: '' };
    learners[i][k] = t.value;

    Array.prototype.forEach.call(document.querySelectorAll('[data-lg]'), function (el) {
      if (el === t) return;
      if (el.getAttribute('data-lg') === k &&
          el.getAttribute('data-i') === String(i) &&
          el.value !== t.value) el.value = t.value;
    });

    var msg = blockedReason();
    Array.prototype.forEach.call(document.querySelectorAll('.lg-warn'), function (w) {
      if (w.hidden) return;
      w.textContent = msg;
      w.hidden = msg === '';
    });
    enforce();
    save();
  }

  var pending = null;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(paint, 250);
  }

  function init() {
    addStyles();
    var btn = document.getElementById('main-cart-checkout');
    if (btn && btn.disabled) btn.setAttribute('data-was-empty', '1');

    document.addEventListener('change', onChange, true);
    document.addEventListener('input', onInput, true);
    document.addEventListener('click', onClick, true);

    paint();
    refreshCart();

    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}

    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(refreshCart, 250); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
